module.exports = __webpack_public_path__ + "static/media/Giddyapp_1.a971a67d.png";